import { render, staticRenderFns } from "./PublicPictureChoice.vue?vue&type=template&id=1510ec34&scoped=true&"
import script from "./PublicPictureChoice.vue?vue&type=script&lang=js&"
export * from "./PublicPictureChoice.vue?vue&type=script&lang=js&"
import style0 from "./PublicPictureChoice.vue?vue&type=style&index=0&id=1510ec34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1510ec34",
  null
  
)

export default component.exports